module.exports = __webpack_public_path__ + "img/shush.8f27b909.svg";